import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import infoList from "../../mixins/infoList";
import { gameplayTypeConfig } from "@/api/config";
import { syncCpConfig } from "@/api/data";
import gameplayTypeOptions from "../../components/serverList/gameplayTypeOptions.vue";
export default {
  components: {
    gameplayTypeOptions: gameplayTypeOptions
  },
  name: "gamePlayTypeConfig",
  mixins: [infoList],
  data: function data() {
    return {
      //分页
      listApi: gameplayTypeConfig,
      searchInfo: {
        gameplay_type_id: ""
      }
    };
  },
  created: function created() {
    this.queryGameplayType();
  },
  methods: {
    queryGameplayType: function queryGameplayType() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getTableData();
            case 2:
              if (!_this.tableData || _this.tableData && _this.tableData.length === 0) {
                _this.$message({
                  message: "暂无数据"
                });
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    openConfig: function openConfig() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return syncCpConfig({
                type: "c_gameplay_type"
              });
            case 2:
              res = _context2.sent;
              if (res.code === 0) {
                _this2.$message({
                  message: "同步cp配置成功",
                  type: "success"
                });
                _this2.queryGameplayType();
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};